import { render, staticRenderFns } from "./ManagerDrawerItem.vue?vue&type=template&id=40d51dd4&scoped=true&"
import script from "./ManagerDrawerItem.vue?vue&type=script&lang=js&"
export * from "./ManagerDrawerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d51dd4",
  null
  
)

export default component.exports